// Provider half of the redirect-URL seam. Split from the Context so
// the Context module exports no components and the `react-refresh`
// lint rule stays happy.
import { useState, type ReactNode } from "react";

import { KindeRedirectContext } from "./KindeRedirectContext";

export const KindeRedirectProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [redirectUrl, setRedirectUrl] = useState<string | null>(null);
  return (
    <KindeRedirectContext.Provider value={{ redirectUrl, setRedirectUrl }}>
      {children}
    </KindeRedirectContext.Provider>
  );
};
